import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  useRef,
} from "react";

const UserDetailsContext = createContext();

export const UserDetailsContextProvider = ({ children }) => {
  const [user, setUser] = useState("");
  useEffect(() => {
    updatingUser();
  }, []);

  const [display, setdisplay] = useState(false);
  const [HRreqularzation, setHRreqularzation] = useState(false);
  const [MangerApproval, setMangerApproval] = useState(false);
  const [componentdisplay, setcomponentdisplay] = useState(false);
  const [leavedisplay, setleavedisplay] = useState(false);
  const [fielddisable, setfielddisable] = useState(false);
  const [totaldays, settotaldays] = useState("");
  const [allyears, setallyears] = useState("");
  const [allmonth, setallmonth] = useState("");
  const [loaction, setLocation] = useState("");
  const [validation, setvalidation] = useState("");
  const [fromdate, setfromdate] = useState("");
  const [enddate, setenddate] = useState("");
  const [shifts, setShifts] = useState("");
  const [department, setDepartment] = useState("");
  const [employee, setEmployee] = useState("");
  const [salaryview, setsalaryview] = useState(false);
  const [salaryedit, setsalaryedit] = useState(false);
  const [viewdisplay, setviewdisplay] = useState(false);
  const [AccessData, setAccessData] = useState([]);
  const [routesdata, setroutesdata] = useState([]);
  const [viewcomponent, setviewcomponent] = useState(true);
  const [update, setupdate] = useState(false);
  const [EmpSubmit, setEmpSubmit] = useState(false);
  const [Empdisplay, setEmpdisplay] = useState(false);
  const [HRRole, setHRRole] = useState(false);
  const [Manager, setManager] = useState(false);
  const [HRRoleLeave, setHRRoleLeave] = useState(false);
  const [ManagerLeave, setManagerLeave] = useState(false);
  const [showemp, setshowemp] = useState(false);
  const [LeaveShow, setLeaveShow] = useState(false);
  const [validationMessages, setValidationMessages] = useState({
    firstName: "",
    lastName: "",
    dob: "",
    email: "",
    gender: "",
    maritalStatus: "",
    address: "",
    country: "",
    state: "",
    city: "",
    zipcode: "",
    countryCode: "",
    contactNumber: "",
    aadharNumber: "",
    panNumber: "",
    joiningDate: "",
    reportingManager: "",
    department: "",
    designation: "",
    shifts: "",
    previousexperience: "",
    probationperiod: "",
    user: "",
  });
  const [MainId, setMainId] = useState("");
  const [RowIDdata, setRowIDdata] = useState([]);
  const [HRLIST, SetHRLIST] = useState("");
  const [HRLISTReg, SetHRLISTReg] = useState("");
 
  const updatingUser = (data) => {
    const userData = sessionStorage.getItem("user");
    const storedData = sessionStorage.getItem("access");

    if (userData && storedData) {
      try {
        const userObject = JSON.parse(userData);
        const allaccessdata = JSON.parse(storedData);

        setUser(userObject);
        setAccessData(allaccessdata);
      } catch (error) {
        console.error("Failed to parse session storage data:", error);
      }
    } else {
      console.warn("User data or access data not found in sessionStorage");
      setUser(null);
      setAccessData(null);
    }
  };
  const [togglePage, setTogglePage] = useState({
    view: true,
    edit: true,
  });
  // newly added 

  const [branches,setBranches]=useState("");
  const[employeeCategory,setEmployeeCategory]=useState("");
  const [employeeType,setEmployeeType] = useState("");
  return (
    <UserDetailsContext.Provider
      value={{
        user,
        updatingUser,
        setdisplay,
        display,
        setcomponentdisplay,
        componentdisplay,
        leavedisplay,
        setleavedisplay,
        setfielddisable,
        fielddisable,
        setTogglePage,
        togglePage,
        totaldays,
        settotaldays,
        allyears,
        setallyears,
        allmonth,
        setallmonth,
        validation,
        setvalidation,
        validationMessages,
        setValidationMessages,
        fromdate,
        setfromdate,
        enddate,
        setenddate,
        salaryview,
        setsalaryview,
        salaryedit,
        setsalaryedit,
        viewdisplay,
        setviewdisplay,
        AccessData,
        routesdata,
        setroutesdata,
        viewcomponent,
        setviewcomponent,
        setLocation,
        loaction,
        setDepartment,
        department,
        employee,
        setEmployee,
        setShifts,
        shifts,
        Empdisplay,
        setEmpdisplay,
        showemp,
        setshowemp,
        HRreqularzation,
        setHRreqularzation,
        MangerApproval,
        setMangerApproval,
        HRRole,
        setHRRole,
        Manager,
        setManager,
        HRRoleLeave,
        setHRRoleLeave,
        ManagerLeave,
        setManagerLeave,
        EmpSubmit,
        setEmpSubmit,
        LeaveShow,
        setLeaveShow,
        update,
        setupdate,
        MainId,
        setMainId,
        RowIDdata,
        setRowIDdata,
        HRLIST,
        SetHRLIST,
        HRLISTReg,
        SetHRLISTReg,
        //
        branches,
        employeeCategory,
        employeeType,
        setEmployeeCategory,
        setEmployeeType,
        setBranches,
      }}
    >
      {children}
    </UserDetailsContext.Provider>
  );
};

export const useUserDetails = () => {
  return useContext(UserDetailsContext);
};

export default UserDetailsContext;
